// @flow

import React from 'react'
import {
    useBlock,
    ImageBlock,
} from '@shift-marketing/shift-one-website-editor'

import withTheme from 'hoc/withTheme'

import styles from './styles.module.scss'
import supportedThemes from './themes/__supportedThemes.js'

import schema from './properties.schema.json'

type Props = {}

function TopBar (props: Props) {
    const { properties, ref } = useBlock('topBar', schema)

    return (
        <div
            ref={ref}
            className={styles.topBar}
            style={{
                color: props.theme.color,
                backgroundColor: properties.backgroundColor,
            }}
        >
            <div className={styles.container}>
                <ImageBlock
                    blockId="header.logo"
                    defaultImage="$.logo.inverted"
                    resize='both'
                    maxWidth='196px'
                    title='Header logo'
                />
            </div>
        </div>
    )
}

export default withTheme(supportedThemes)(TopBar)
